import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ApiKeyPermission = React.lazy(() =>
    import('../ApiKeyPermission')
);
const apiKeyPermissionRoutesRegistry = [
    {
        path: PAGE_URL.API_KEY_PERMISSION_PAGE,
        element: <ApiKeyPermission />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default apiKeyPermissionRoutesRegistry;
